import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UserAuth } from 'src/app/common/user-auth';
import { NotificationService } from 'src/app/common/notification.service';
import { SkynetixAssistantService } from './skynetix-assistant.service';

@Component({
  selector: 'app-skynetix-assistant',
  templateUrl: './skynetix-assistant.component.html',
  styleUrls: ['./skynetix-assistant.component.scss'],
})
export class SkynetixAssistantComponent implements OnInit {
  visible = false;
  opened = false;
  loading = false;
  errored = false;
  errorMessage: string | null = null;
  embedUrl: SafeResourceUrl | null = null;

  constructor(
    private skynetixService: SkynetixAssistantService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.visible = [35, 1222, 1].includes(UserAuth.get().id);
    // this.visible = !UserAuth.get().isExternal;
  }

  open(): void {
    this.opened = true;

    if (this.embedUrl || this.loading) {
      return;
    }

    this.errored = false;
    this.errorMessage = null;
    this.loading = true;
    this.skynetixService.getEmbedUrl().subscribe((result) => {
      this.loading = false;
      if (result.url) {
        this.embedUrl = result.url;
      } else {
        this.errored = true;
        this.errorMessage = result.errorMessage;
        this.notificationService.showError(
          result.errorMessage ?? 'SkynetiX Assistent ist derzeit nicht verfügbar.'
        );
      }
    });
  }

  close(): void {
    this.opened = false;
  }
}
